import { useMutation, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';

import { fetchROC } from '@/adapters/fetchExaCare';
import { FIND_ALL_OUTBOUND_REFERRALS_QUERY_KEY } from '@/pages/CRM/ReferralOutbound/hooks/useOutboundReferralsQuery';

import { REFERRAL_DETAIL_QUERY_KEY } from './useReferralDetailQuery';

interface UpdateReferralParams {
  target_discharge_date: Date;
}

export function useUpdateReferralMutation(referralId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: UpdateReferralParams) =>
      fetchROC.patch(`/referrals/${referralId}`, {
        json: {
          target_discharge_date: dayjs(params.target_discharge_date).format(
            'YYYY-MM-DD'
          )
        }
      }),
    onSuccess: () => {
      queryClient.invalidateQueries([REFERRAL_DETAIL_QUERY_KEY, referralId]);
      queryClient.invalidateQueries([FIND_ALL_OUTBOUND_REFERRALS_QUERY_KEY]);
    }
  });
}
